<template>
  <MainLayout class="hide-header-menu inquiry-form">
    <div class="container" slot="layout-body">
      <div class="row inquiry-form-header">
        <div class="col-12">
          <div class="inquiry-form-header__title text-center">
            {{ $t('inquiry_form.header.title') }}
          </div>

          <div class="inquiry-form-header__subtitle text-center">
            {{ $t('inquiry_form.header.subtitle') }}
          </div>
        </div>
      </div>

      <div class="row inquiry-form-form">
        <div class="col-12 mx-auto">
          <div class="form-group" v-bind:class="{ 'has-danger': errors.has('schoolName') }">
            <label for="school-name-input" class="inquiry-form-form__label">
              <strong>{{ $t('inquiry_form.form.school_name') }}</strong><span class="typography--color-accent">*</span>
            </label>
            <input type="text"
                   class="form-control basic-text-input"
                   v-bind:class="{ 'form-control-danger': errors.has('schoolName') }"
                   id="school-name-input"
                   v-bind:placeholder="$t('inquiry_form.form.school_name_placeholder')"
                   maxlength="50"
                   v-model="schoolName"
                   required>
          </div>

          <div class="form-group" v-bind:class="{ 'has-danger': errors.has('name') }">
            <label for="name-input" class="inquiry-form-form__label">
              <strong>{{ $t('inquiry_form.form.name') }}</strong><span class="typography--color-accent">*</span>
            </label>
            <input type="text"
                   class="form-control basic-text-input"
                   v-bind:class="{ 'form-control-danger': errors.has('name') }"
                   id="name-input"
                   v-bind:placeholder="$t('inquiry_form.form.name_placeholder')"
                   maxlength="50"
                   v-model="name"
                   required>
          </div>

          <div class="form-group" v-bind:class="{ 'has-danger': errors.has('position') }">
            <label for="position-input" class="inquiry-form-form__label">
              <strong>{{ $t('inquiry_form.form.position') }}</strong><span class="typography--color-accent">*</span>
            </label>
            <input type="text"
                   class="form-control basic-text-input"
                   v-bind:class="{ 'form-control-danger': errors.has('position') }"
                   id="position-input"
                   v-bind:placeholder="$t('inquiry_form.form.position_placeholder')"
                   maxlength="50"
                   v-model="position"
                   required>
          </div>

          <div class="form-group" v-bind:class="{ 'has-danger': errors.has('email') }">
            <label for="email-input" class="inquiry-form-form__label">
              <strong>{{ $t('inquiry_form.form.email') }}</strong><span class="typography--color-accent">*</span>
            </label>
            <input type="email"
                   class="form-control basic-text-input"
                   v-bind:class="{ 'form-control-danger': errors.has('email') }"
                   id="email-input"
                   v-bind:placeholder="$t('inquiry_form.form.email_placeholder')"
                   maxlength="50"
                   v-model="email"
                   required>
          </div>

          <div class="form-group" v-bind:class="{ 'has-danger': errors.has('mobile') }">
            <label for="mobile-input" class="inquiry-form-form__label">
              <strong>{{ $t('inquiry_form.form.mobile') }}</strong><span class="typography--color-accent">*</span>
            </label>
            <input type="tel"
                   class="form-control basic-text-input"
                   v-bind:class="{ 'form-control-danger': errors.has('mobile') }"
                   id="mobile-input"
                   v-bind:placeholder="$t('inquiry_form.form.mobile_placeholder')"
                   maxlength="50"
                   v-model="mobile"
                   required>
          </div>

          <div class="form-group">
            <label for="content-input" class="inquiry-form-form__label">
              <strong>{{ $t('inquiry_form.form.content') }}</strong>
            </label>
            <textarea class="form-control basic-text-input"
                      id="content-input"
                      v-bind:placeholder="$t('inquiry_form.form.content_placeholder')"
                      rows="6"
                      v-model="content">
            </textarea>
          </div>

          <div class="text-center">
            <button class="btn btn-primary btn-full inquiry-form-form__submit-btn"
                    v-bind:disabled="isFormInvalid"
                    v-on:click="submit()">
              <span v-if="!busy">{{ $t('inquiry_form.form.submit_btn') }}</span>
              <LoadingBounce v-else></LoadingBounce>
            </button>
          </div>
        </div>
      </div>

      <div class="row inquiry-form-contact">
        <div class="col-12">
          <div class="inquiry-form-contact__title text-center">
            {{ $t('inquiry_form.contact.title') }}
          </div>

          <div class="inquiry-form-contact__subtitle text-center">
            <a v-bind:href="`tel:${$t('inquiry_form.contact.subtitle')}`"
                class="btn btn-outline-primary inquiry-form-contact__subtitle-btn">
              {{ $t('inquiry_form.contact.subtitle') }}
            </a>
          </div>

          <div class="inquiry-form-contact__desc text-center">
            {{ $t('inquiry_form.contact.desc') }}
          </div>
        </div>
      </div>

      <div class="row inquiry-form-footer">
        <div class="col-12 text-center">
          <FooterContent></FooterContent>
        </div>
      </div>
    </div>

    <div slot="modal-area">
      <b-modal id="inquiry-submitted-alert"
               class="basic-modal no-header-modal hide-cancel-btn"
               v-bind:hide-header="true"
               v-bind:no-close-on-backdrop="true"
               v-bind:ok-title="$t('common.confirm')"
               v-on:ok="goBack">
        <div v-html="$t('inquiry_form.modal.inquiry_submitted_alert')"></div>
      </b-modal>

      <b-modal id="basic-error-alert"
               class="basic-modal no-header-modal hide-cancel-btn"
               v-bind:hide-header="true"
               v-bind:ok-title="$t('common.confirm')">
        <div v-html="$t('common.modal.basic_error_alert.message')"></div>
      </b-modal>
    </div>
  </MainLayout>
</template>

<script>
  import { Validator } from 'vee-validate';
  import { mapActions } from 'vuex';
  import { GOOGLE_FORMS } from '@/config';

  export default {
    name: 'inquiry-form',

    validator: null,

    data() {
      return {
        errors: null,

        busy: false,

        schoolName: '',

        name: '',

        position: '',

        email: '',

        mobile: '',

        content: '',
      };
    },

    watch: {
      schoolName(value) {
        this.validator.validate('schoolName', value);
      },

      name(value) {
        this.validator.validate('name', value);
      },

      position(value) {
        this.validator.validate('position', value);
      },

      email(value) {
        this.validator.validate('email', value);
      },

      mobile(value) {
        this.validator.validate('mobile', value);
      },
    },

    computed: {
      isFormInvalid() {
        return (this.schoolName === '' ||
          this.name === '' ||
          this.position === '' ||
          this.email === '' ||
          this.mobile === '' ||
          this.errors.any());
      },
    },

    methods: {
      ...mapActions([
        'sendSlackNotification',
        'submitGoogleForms',
      ]),

      submit() {
        this.busy = true;

        const params = {
          url: GOOGLE_FORMS.url,
          fields: {},
        };

        params.fields[GOOGLE_FORMS.fields.schoolName] = this.schoolName;
        params.fields[GOOGLE_FORMS.fields.name] = this.name;
        params.fields[GOOGLE_FORMS.fields.position] = this.position;
        params.fields[GOOGLE_FORMS.fields.email] = this.email;
        params.fields[GOOGLE_FORMS.fields.mobile] = this.mobile;
        params.fields[GOOGLE_FORMS.fields.content] = this.content;

        const slackParams = {
          school_name: this.schoolName,
          name: this.name,
          position: this.position,
          email: this.email,
          mobile: this.mobile,
          content: this.content,
        };

        this.submitGoogleForms(params)
          .then(() => (
            this.sendSlackNotification(slackParams)
          ))
          .then(() => {
            this.$root.$emit('show::modal', 'inquiry-submitted-alert');
            this.busy = false;
          })
          .catch(() => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            this.busy = false;
          });
      },

      goBack() {
        this.$router.back();
      },
    },

    created() {
      this.validator = new Validator({
        schoolName: {
          required: true,
        },
        name: {
          required: true,
        },
        position: {
          required: true,
        },
        email: {
          required: true,
          email: true,
        },
        mobile: {
          required: true,
          regex: /^\d{3}-?\d{3,4}-?\d{4}$/,
        },
      });

      this.$set(this, 'errors', this.validator.errorBag);
    },
  };
</script>

<style lang="scss">
  .inquiry-form {
    .layout-body {
      padding-top: 0;
    }

    .inquiry-form-header {
      margin-top: 60px;

      .inquiry-form-header__title {
        font-size: 28px;
        line-height: 1.79;
        color: rgba(0, 0, 0, 0.87);
      }

      .inquiry-form-header__subtitle {
        margin-top: 6px;
        font-size: 16px;
        line-height: 2.25;
        color: rgba(0, 0, 0, 0.54);
      }
    }

    .inquiry-form-form {
      margin-top: 40px;

      .col-12 {
        max-width: 400px;
      }

      .form-group {
        margin-bottom: 10px;
      }

      .inquiry-form-form__label {
        font-size: 16px;
        font-weight: 400;
        line-height: 1.88;
        color: rgba(0, 0, 0, 0.54);
      }

      .inquiry-form-form__submit-btn {
        font-size: 16px;
        line-height: 1.88;
        font-weight: 400;
        padding-top: 5px;
        padding-bottom: 5px;
        border-radius: 4px;
      }
    }

    .inquiry-form-contact {
      margin-top: 60px;

      .inquiry-form-contact__title {
        font-size: 20px;
        font-weight: 500;
        line-height: 2.5;
        color: rgba(0, 0, 0, 0.87);
      }

      .inquiry-form-contact__subtitle {
        margin-top: 12px;
      }

      .inquiry-form-contact__subtitle-btn {
        border-radius: 4px;
        border: solid 2px #00c896;
        padding-top: 6px;
        padding-bottom: 6px;
        min-width: 146px;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.88;
        color: #00c896;
        transition: background-color .3s ease, color .3s ease;

        &:hover,
        &:active {
          background-color: #00c896;
          color: #fff;
        }
      }

      .inquiry-form-contact__desc {
        margin-top: 10px;
        font-size: 16px;
        font-weight: 500;
        line-height: 1.75;
        color: rgba(0, 0, 0, 0.54);
      }
    }

    .inquiry-form-footer {
      padding-top: 60px;
      padding-bottom: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/InquiryForm.vue